import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import { serverError } from 'src/utils';

const mutation = gql`
mutation CreateTimeout($model: ChannelTeamRequestTypeTimeoutInput!) {
  createChannelTeamRequestTypeTimeout(ChannelTeamRequestTypeTimeout: $model){
    id
    autoholdChatTimeout
    autocloseMsgTimeout
    autocloseChatTimeout
    inactiveChatAutocloseMsg
    team {
      id
      name
    }
    requestType{
      id
      name
    }
    channel {
      id
      name
    }
  }
}`;

const fieldsName = {
  name: 'T_TIMEOUT_MESSAGE',
  event: 'T_EVENT',
};

function onParseErrors(item) {
  return serverError.interpolation(item, fieldsName);
}

function createTimeout(model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      model,
    },
  }).then((res) => res.data.createChannelTeamRequestTypeTimeout)
    .catch((err) => {
      if (err.graphQLErrors.length) {
        const errors = err.graphQLErrors[0].error.payload;
        throw errors.map(onParseErrors);
      } else {
        throw err;
      }
    });
}

export default createTimeout;
